// extracted by mini-css-extract-plugin
module.exports = {"Category_h1":"Heading_Category_h1__2Rw23","Empty":"Heading_Empty__3wbjv"};